import React from 'react';
import { observer } from 'mobx-react';

import { Flex } from 'grid-styled';

import { Select } from '../styledSystem/Select';
import { Label } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';
import Option from '../styledSystem/Option';

const ModalSelect = observer(
    class extends React.Component {
        state = {
            hover: false
        };

        componentDidUpdate(prevProps) {
            //console.log("updated!");
            //console.log(this.props.optionsValue[0]);
            //console.log(prevProps);
            //console.log(this.props);
            //console.log(prevProps.optionsValue);
            //console.log(this.props.optionsValue);
            if (
                this.arraysDiffer(
                    prevProps.optionsValue,
                    this.props.optionsValue
                )
            ) {
                console.log('changed!');
                console.log(this.props.name);
                this.props.model[this.props.name] = this.props.optionsValue[0];
                this.props.validateModel();
                console.log(
                    'ModalSelect: model[' +
                    this.props.name +
                    ']=' +
                    this.props.optionsValue[0]
                );
            }
        }

        arraysDiffer(arr1, arr2) {
            if (arr1.length !== arr2.length) {
                return true;
            }
            for (let i = 0; i < arr1.length; i++)
                if (arr1[i] !== arr2[i]) {
                    return true;
                }
            return false;
        }

        onChange = ({ target }) => {
            const { model, name } = this.props;
            model[name] = target.value;

            this.props.validateModel();

            console.log('ModalSelect: model[' + name + ']=' + target.value);
        };

        handleMouseIn() {
            this.setState({ hover: true });
        }

        handleMouseOut() {
            this.setState({ hover: false });
        }

        render() {
            const {
                model,
                name,
                label,
                optionsValue,
                optionsName,
                ...props
            } = this.props;

            const tooltipStyle = {
                display: this.state.hover ? 'block' : 'none',
                position: 'absolute',
                right: 0,
                margin: 0,
                top: '5px',
                backgroundColor: '#c1272d',
                width: '70%',
                padding: '5px'
            };

            let optionNodes = [];
            if (optionsValue && optionsName) {
                for (let k = 0; k < optionsValue.length; k++) {
                    optionNodes.push(
                        <Option key={optionsName[k]} value={optionsValue[k]}>
                            {optionsName[k]}
                        </Option>
                    );
                }
            }

            return (
                <Flex w={1} pt={'3px'} pb={'3px'}>
                    <BoxTemplate textalign="left" w={1 / 2}>
                        <Label textStyle="labelNormal">{label}</Label>
                    </BoxTemplate>
                    <BoxTemplate w={1 / 2}>
                        <div
                            onMouseOver={this.handleMouseIn.bind(this)}
                            onMouseOut={this.handleMouseOut.bind(this)}
                        >
                            <Select
                                {...props}
                                onChange={this.onChange}
                                value={model[name]}
                            >
                                {optionNodes}
                            </Select>
                        </div>
                        {this.props.statevariable &&
                        this.props.statevariable.formErrors[name] ? (
                            <BoxTemplate position="relative">
                                <BoxTemplate style={tooltipStyle}>
                                    <Label color="white" textStyle="labelSmall">
                                        {
                                            this.props.statevariable.formErrors[
                                                name
                                            ]
                                        }
                                    </Label>
                                </BoxTemplate>
                            </BoxTemplate>
                        ) : (
                            ''
                        )}
                    </BoxTemplate>
                </Flex>
            );
        }
    }
);

export default observer(ModalSelect);



// WEBPACK FOOTER //
// ./src/form/ModalSelect.js